var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgNotiz = function SvgNotiz(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 14 14",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 0H1.2C.5 0 0 .5 0 1.2V10c0 .6.5 1.2 1.2 1.2h1.2v2.3c0 .3.3.6.6.6.2 0 .4-.1.5-.2l2-2.7h7.4c.6 0 1.2-.5 1.2-1.2V1.2C14 .5 13.5 0 12.8 0M2.9 3.6h6v1.2h-6zm8.2 3.8H2.9V6.3h8.2z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNotiz);
export default ForwardRef;